import React from "react";

import "./styles.css";

interface UserAvatarIconProps {
  className?: string;
}

const UserAvatarIcon = ({ className = "" }: UserAvatarIconProps) => (
  <span
    className={`user-avatar-icon${className ? ` ${className}` : ""}`}
    aria-hidden="true"
  >
    <span className="user-avatar-icon__head" />
    <span className="user-avatar-icon__body" />
  </span>
);

export default UserAvatarIcon;
